import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import Modal from 'utils/packages/Modal';
import Spacer from 'design-system/Spacer';
import { IconEdit, IconTrash } from 'design-system/icons';
import { SettingsItem } from 'design-system/SettingsItem';
import useColors from 'hooks/useColors';
import { useAppDispatch } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { deleteStockAlert } from '../actions';
const StockAlertOptionsModalContent = ({ alertId, assetId, alertPriceValue, alertPriceCurrency, }) => {
    const colors = useColors();
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    const onPress = useCallback(() => {
        dispatch(deleteStockAlert(alertId, assetId));
        Modal.hide();
    }, [alertId, assetId]);
    const onEdit = useCallback(() => {
        Modal.hide(() => {
            navigation.navigateDeprecated('InvestSetStockAlertScreen', {
                assetId,
                id: alertId,
                alertPriceValue,
                alertPriceCurrency,
            });
        });
    }, [alertId, alertPriceCurrency, alertPriceValue, assetId]);
    return (<>
      <Spacer h={32}/>
      <TouchableHighlight hoverOnLight activeOpacity={1} onPress={onEdit} underlayColor={colors.background.underlay}>
        <SettingsItem title="Edit" icon={<IconEdit gradientKey="darkPurple"/>}/>
      </TouchableHighlight>
      <TouchableHighlight hoverOnLight activeOpacity={1} onPress={onPress} underlayColor={colors.background.underlay}>
        <SettingsItem title="Delete" icon={<IconTrash colorKey="negative"/>}/>
      </TouchableHighlight>
    </>);
};
export const StockAlertOptionsModal = {
    show: (assetId, alertId, alertPriceValue, alertPriceCurrency) => {
        Modal.show(<StockAlertOptionsModalContent alertId={alertId} assetId={assetId} alertPriceValue={alertPriceValue} alertPriceCurrency={alertPriceCurrency}/>, {
            title: '',
            containerStyle: modalStyles.modal,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const modalStyles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
